import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { vegetationSuppressionService } from "../../../services/vegetationSuppressionService";
import { StyledButtonForm } from "../DetailsArea/styles";
import {
  Section,
  SectionTitle,
  Hint,
  CardList,
  Card,
  CardTitle,
  CardMeta,
  CardActions,
  Empty,
  StatusPill,
  TiffLink,
} from "./styles";

const VegetationSuppressionPanel = ({ areaId, archived = false }) => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    if (!areaId) return;
    setLoading(true);
    try {
      const list = await vegetationSuppressionService.list(areaId);
      setItems(Array.isArray(list) ? list : []);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areaId]);

  const handleDelete = async (id) => {
    if (!window.confirm("Excluir este registro de supressão e o TIFF associado?")) {
      return;
    }
    try {
      await vegetationSuppressionService.remove(areaId, id);
      setItems((prev) => prev.filter((x) => x.id !== id));
    } catch (err) {
      console.error(err);
      window.alert("Não foi possível excluir.");
    }
  };

  return (
    <Section>
      <SectionTitle>Supressão de vegetação (ASV)</SectionTitle>
      <Hint>
        Cadastre cenas TIFF (Landsat/Sentinel), marque a área de indicação de
        supressão sobre a imagem e salve vinculada a esta área e à data da
        observação.
      </Hint>
      {!archived && (
        <div style={{ marginBottom: "0.85rem" }}>
          <StyledButtonForm
            type="button"
            onClick={() =>
              navigate(`/area_details/${areaId}/vegetation-suppression/new`)
            }
          >
            + Cadastrar nova supressão
          </StyledButtonForm>
        </div>
      )}
      {loading ? (
        <Empty>Carregando registros…</Empty>
      ) : items.length === 0 ? (
        <Empty>Nenhuma supressão cadastrada para esta área.</Empty>
      ) : (
        <CardList>
          {items.map((item) => {
            const feats = item.suppression_geometry?.features?.length || 0;
            return (
              <Card key={item.id}>
                <CardTitle>
                  {item.title || item.original_filename || "Sem título"}
                  <StatusPill $confirmed={item.status === "confirmed"}>
                    {item.status === "confirmed" ? "Confirmado" : "Rascunho"}
                  </StatusPill>
                </CardTitle>
                <CardMeta>
                  Observação:{" "}
                  {item.observation_date
                    ? new Date(
                        item.observation_date + "T12:00:00"
                      ).toLocaleDateString("pt-BR")
                    : "—"}
                  {item.area_ha != null ? ` · ${item.area_ha} ha` : ""}
                </CardMeta>
                <CardMeta>
                  Polígonos: {feats}
                  {item.created_by_name ? ` · por ${item.created_by_name}` : ""}
                </CardMeta>
                <CardActions>
                  <StyledButtonForm
                    type="button"
                    secondary
                    onClick={() =>
                      navigate(
                        `/area_details/${areaId}/vegetation-suppression/${item.id}`
                      )
                    }
                  >
                    Visualizar / Editar
                  </StyledButtonForm>
                  {item.original_tiff_url && (
                    <TiffLink
                      href={item.original_tiff_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Baixar TIFF original
                    </TiffLink>
                  )}
                  {!archived && (
                    <StyledButtonForm
                      type="button"
                      secondary
                      onClick={() => handleDelete(item.id)}
                      style={{ color: "var(--danger)" }}
                    >
                      Excluir
                    </StyledButtonForm>
                  )}
                </CardActions>
              </Card>
            );
          })}
        </CardList>
      )}
    </Section>
  );
};

export default VegetationSuppressionPanel;
